import { useEvaluationUserContext } from '~/app/evaluations/userContext'
import { EvaluationCollaborator } from './useEvaluationCollaborators'

export enum StandardRoles {
  admin = 'Admin',
  editor = 'Editor',
  viewer = 'Viewer',
}

enum EvaluationPermissions {
  canEdit = 'evaluation:edit',
  canChangeStatus = 'evaluation:edit',
}

function hasCollaboratorPermission({
  collaborator,
  permission,
}: {
  collaborator?: EvaluationCollaborator
  permission: string
}) {
  return collaborator?.allowPermissions?.includes(permission)
}

function hasCollaboratorRole({
  collaborator,
  role,
}: {
  collaborator?: EvaluationCollaborator
  role: string
}) {
  // Backend returns capitalized roles (Admin, Editor, Viewer, Owner)
  // Use case-insensitive comparison for robustness
  return collaborator?.roles?.some(
    (r) => r.toLowerCase() === role.toLowerCase()
  )
}

export function canCollaboratorEditEvaluation(
  collaborator?: EvaluationCollaborator
) {
  return (
    hasCollaboratorRole({
      collaborator,
      role: StandardRoles.admin,
    }) ||
    hasCollaboratorRole({
      collaborator,
      role: StandardRoles.editor,
    })
  )
}

export function useCanEditEvaluation() {
  const evalContext = useEvaluationUserContext()
  return canCollaboratorEditEvaluation(evalContext?.collaborator)
}

export function canCollaboratorUpdateEvaluationStatus(
  collaborator?: EvaluationCollaborator
) {
  return (
    hasCollaboratorRole({
      collaborator,
      role: StandardRoles.admin,
    }) ||
    hasCollaboratorRole({
      collaborator,
      role: StandardRoles.editor,
    }) ||
    hasCollaboratorRole({
      collaborator,
      role: 'Owner',
    })
  )
}

export function useCanUpdateEvaluationStatus() {
  const evalContext = useEvaluationUserContext()
  return canCollaboratorUpdateEvaluationStatus(evalContext?.collaborator)
}
